import { AreaList } from '../../types/main';

export const getOptionsFromAreaList = (areaList: AreaList[]) =>
  areaList.map(({ guid, title }) => ({ id: guid, label: title }));
